/*
 * @name: name
 * 
 * @Author: 黄晓玲
 * @Date: 2022-11-27 10:03:58
 * @LastEditors: 黄晓玲
 * @LastEditTime: 2022-12-01 13:33:39
 * @Description: 描述
 */

export default {
    // 路由国际化
    route: {
        dashboard: "首页",
        document: "项目文档",
        Home: '首页',
        companyProfile: '关于我们',
        newsInformation: "新闻信息",
        ProductCenter: '产品与服务',
        ResourceLibrary: '资源中心',
        Pilot: '客户服务',
        Contact: '联系我们',
        talentRecruitment: '人才招聘',
        noticesAndMap: '声明与地图',
    },
    // 登录页面国际化
    login: {
        title: "vue3-element-admin",
        username: "用户名",
        password: "密码",
        login: "登 录",
        code: "请输入验证码",
        copyright: "",
        icp: "",
    },
    navbar: {
        login: '登录',
        logout: "注销",
        en: 'English',
        zhCn: '简体中文',
        language: '语言',
    },
    home: {
        title1: '公司简介',
        title2: '党建要闻',
        title2_more: '查看所有要闻',
        title3: '新闻信息',
        title3_more: '查看更多',
        title4: '合作伙伴',
        company: '公司信息',
        searchTips: '请输入关键词',
        searchBtn: '搜 索',
        source: '来源',
        abstract: '摘要',
        organizationalStructure: '组织架构'
    },
    companyProfile: {
        companyProfile: '公司介绍',
        companyStructure: '组织架构',
        corporateCulture: '企业文化',
        corporateHonor: '企业荣誉',
        development: '发展历程',
        customers: '我们的客户',
        partners: '合作伙伴',
        chinaSouthernAirlines: '南航集团介绍',
    },
    news: {
        companyNews: '公司新闻',
        allNews: '查看所有新闻',
        industryNews: '行业动态',
        allIndustryNews: '查看所有动态',
        informationDisclosure: '信息公开',
        newsDetail: '新闻详情',
        dynamicDetail: '动态详情',
        informationDetail: '信息详情',
        detail: '详情',
        year: '年份',
        selectYear: '选择年份',
    },
    productCenter: {
        productDetail: '产品详情',
        viewNow: '立即查看',
    },
    resource: {
        type: '类型',
        format: '格式',
        date: '日期',
        startDate: '开始日期',
        endDate: '结束日期',
        to: '至',
        reading: '阅读',
        down: '下载',
        abstract: '摘要',
        updateTime: '更新时间'
    },
    pilotService: {
        planQuery: '计划查询',
        simulatorPlan: '模拟机计划查询',
        TheoreticalPlan: "理论计划查询",
        simulator: '模拟机计划',
        Theoretical: "理论计划",
        otherTitle: '其他服务',
        SelfServicePrinting: "自助打印",
        Training: "训练须知",
        LostAndFound: "失物招领",
        QuestionnaireInvestigation: "问卷调查",
        questionnaireDetails: "问卷详情",
        TrafficGuidance: "交通指引",
        ParkServiceSuggestions: '园区服务建议',
        OnlineLearningSystem: '在线学习系统',
        planTable: {
            applicationDate: '申请日期',
            serialNumber: '序号',
            date: '日期',
            time: '时间',
            equipment: '设备',
            trainingNature: '训练性质',
            teacher: '教员',
            student: '学员',
            position: '位置',
        }
    },
    contactUs: {
        contactInformation: '联系方式',
        talentRecruitment: '人才招聘',
        positionDetails: '职位详情',
        chinaSouthernAirlinesGroup: '南航集团',
        contactInfo: {
            address: '地址',
            postalCode: '邮编',
            phone: '电话',
            feedback: '意见反馈',
            consultation: '在线客服'
        },
        recruitmentTable: {
            jobTitle: '职位名称',
            department: '招聘部门',
            recruitmentCategory: '招聘类别',
            workingLocation: '工作地点',
            releaseTime: '发布时间',
            jobDescription: '职责描述',
            qualification: '任职资格',
            HRContactInformation: 'HR联系方式',
            chooseDepartment: '请选择招聘部门',
            chooseCategory: '请选择招聘类别',
            chooseLocation: '请选择工作地点',
            choosePosition: '请输入职位名称',
        }
    },
    legalAndMap: {
        legalStatement: '法律声明',
        siteMap: '网站地图'
    },
    login: {
        login: '登录',
        SMSLOGIN: '短信登录',
        mobileNumber: '手机号',
        SMSCode: '短信验证码',
        SEND: '获取验证码',
        captchaCode: '图形验证码'
    },
    footer: {
        officialWeChat: '官方公众号',
        officialVideo: '官方视频号',
        officialTiktok: '官方抖音号',
        companyName: '版权所有(C)珠海翔翼航空技术有限公司'
    }
};